<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">
    <form class="ng-untouched ng-pristine ng-valid" #formEditCompany="ngForm" novalidate>
      <div id="containerVacaciones" class="row">
        <dx-load-panel #loadPanel shadingColor="rgba(231, 231, 231,0.4)" [position]="{ of: '#containerVacaciones' }"
          [visible]="!bolsaVacaciones || !diasVacaciones" [showIndicator]="true" [showPane]="true" [shading]="true"
          [closeOnOutsideClick]="false">
        </dx-load-panel>
        <div class="col-sm-12 col-lg-4 ml-auto mt-3 mb-3">
          <div class="row">
            <legend>Bolsa vacaciones</legend>

            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="DiasIT" placeholder="Días de IT/Absentismo"
                  [(ngModel)]="bolsaVacaciones && bolsaVacaciones.DiasIt" style="text-align: right" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="Importe" currencyMask placeholder="Importe bolsa"
                  [(ngModel)]="bolsaVacaciones && bolsaVacaciones.Importe" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="ImporteProporcional" currencyMask placeholder="Parte proporcional"
                  [(ngModel)]="
                      bolsaVacaciones && bolsaVacaciones.ImporteProporcional
                    " readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="ImporteCobrado" currencyMask placeholder="Cobrado" [(ngModel)]="
                      bolsaVacaciones && bolsaVacaciones.ImporteCobrado
                    " readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="Total" currencyMask placeholder="Total"
                  [(ngModel)]="bolsaVacaciones && bolsaVacaciones.Total" readonly />
              </mat-form-field>
            </div>

          </div>
        </div>
        <div class="col-sm-12 col-lg-4 mr-auto mt-3 mb-3">
          <div class="row">
            <legend>Días de vacaciones</legend>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="DiasPorConvenio" placeholder="Días vacaciones por convenio"
                  [(ngModel)]="diasVacaciones && diasVacaciones.DiasPorConvenio" style="text-align: right" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="CompensacionFestivos" placeholder="Compensación festivos" [(ngModel)]="
                    diasVacaciones && diasVacaciones.CompensacionFestivos
                  " style="text-align: right" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="Suma" placeholder="Suma"
                  [(ngModel)]="diasVacaciones && diasVacaciones.Suma" style="text-align: right" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="DiasDisfrutados" placeholder="Días disfrutados"
                  [(ngModel)]="diasVacaciones && diasVacaciones.DiasDisfrutados" style="text-align: right" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="TotalVacaciones" placeholder="Total"
                  [(ngModel)]="diasVacaciones && diasVacaciones.Total" style="text-align: right" readonly />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- Botonera -->
    <div class="row">

      <div class="col-md-9">
        <div class="form-group form-button">
          <!-- <a
            class="btn btn-fill btn-outline-white float-right"
            (click)="goBack()"
            >Volver</a
          > -->
        </div>
      </div>
    </div>
  </app-generic-panel>
</app-generic-container>
